import styled from 'styled-components';
import star from '~/assets/icons/star.svg';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;
	margin-top: 20px;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const StyledAvatar = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 100px;
	border-radius: 100px;
	background-color: rgba(217, 217, 217, 0.1);
	margin-top: 20px;

	${Text} {
		font-weight: 500;
		font-size: 40px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	gap: 5px;
	grid-template-columns: repeat(3, 1fr);
	margin-top: 40px;
	width: 340px;

	img {
		width: 20px;
		height: 20px;
	}
`;

const StyledStarIcon = styled.div`
	width: 20px;
	height: 20px;
	mask-image: url(${star});
	mask-size: contain;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${star});
	-webkit-mask-size: contain;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	transition: background-color 0.3s ease;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 20px;
`;

const StyledInfoItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 340px;
	height: 50px;
	padding: 0 20px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	${Text} {
		font-size: 18px;
		color: #ffffff;

		&:first-child {
			opacity: 0.25;
		}

		&:last-child {
			font-weight: 500;
		}
	}
`;

export {
	StyledAvatar,
	StyledButtonsContainer,
	StyledContainer,
	StyledHead,
	StyledInfoContainer,
	StyledInfoItem,
	StyledStarIcon,
};
